import getStore from '../store/store';

/**
 * Selector to get if the user has not set up personal bookings and is a first time personal bookings user from the store.
 */
export default function isFirstTimePersonalBookingUser(): boolean {
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2532 (10,12): Object is possibly 'undefined'.
    // @ts-expect-error
    return getStore().firstTimeUserSettings.firstTimePersonalBookingUser;
}
